import { ajaxSend } from 'api/api';
export function flowGetAll(payload = { channel: 'widgetchat' }) {
    return ajaxSend({
        path: `/v1/flows?channel=${payload.channel}`,
    });
}
